import React, { FunctionComponent } from 'react';
import { AutomationTemplate } from './AutomationTemplate';
import styles from './AutomationTemplateCategory.module.css';
import {
  AutomationTemplateCategoryDefinition,
  AutomationTemplateChannel,
  AutomationTemplateDefinition,
} from './Templates/TemplateDefinitions';

interface Props {
  category: AutomationTemplateCategoryDefinition;
  templateChannel: AutomationTemplateChannel;
  setActiveTemplate: (template: {
    template: AutomationTemplateDefinition;
    channel: AutomationTemplateChannel;
  }) => void;
  activeStep: number;
  setActiveStep: (step: number) => void;
  outboundAutomationParams?: any;
  closeModal?: () => void;
}

export const AutomationTemplateCategory: FunctionComponent<Props> = props => {
  const {
    category,
    setActiveTemplate,
    templateChannel,
    activeStep,
    setActiveStep,
    outboundAutomationParams,
    closeModal,
  } = props;
  return (
    <div className={styles.container}>
      {!!category.tags.length && (
        <div className={styles.tags}>
          {category.tags.map(tag => (
            <div className={styles.tag} key={tag.title}>
              <tag.icon />
              <div>{tag.title}</div>
            </div>
          ))}
        </div>
      )}
      <div className={styles.heading}>{category.categoryName}</div>
      <div className={styles.templates}>
        {category.templateNames.map(templateName => (
          <AutomationTemplate
            key={templateName}
            templateName={templateName}
            highlight={category.highlightTemplates}
            setActiveTemplate={setActiveTemplate}
            templateChannel={templateChannel}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            outboundAutomationParams={outboundAutomationParams}
            closeModal={closeModal}
          />
        ))}
      </div>
    </div>
  );
};
